import React, { useCallback, useState } from "react"

import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin"
import { LexicalComposer } from "@lexical/react/LexicalComposer"
import { ContentEditable } from "@lexical/react/LexicalContentEditable"
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary"
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin"
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin"
import { PlainTextPlugin } from "@lexical/react/LexicalPlainTextPlugin"

import { EscapeHandlerPlugin } from "./EscapeHandlerPlugin"
import { ClearEditorPlugin } from "@lexical/react/LexicalClearEditorPlugin"
import { EditorRefPlugin } from "@lexical/react/LexicalEditorRefPlugin"
import styles from "./styles.module.css"
import CommentTheme from "../../theme/CommentEditorTheme"
import { MentionsPlugin } from "../MentionPlugin"
import { MentionNode } from "../../nodes/MentionNode"
import { Menu, MenuItem } from "../../components/CustomMenu"
import { memo } from "react"

export const PlainTextEditor = memo(
  ({
    className,
    autoFocus,
    onEscape,
    onChange,
    editorRef,
    editorState = null,
    editable = true,
    placeHolder = "Введите комментарий",
    namespace = "Commenting",
  }) => {
    const initialConfig = {
      namespace,
      editable,
      nodes: [MentionNode],
      editorState,
      onError: (error) => {
        throw error
      },
      theme: CommentTheme,
    }
    const [ismenuOpen, setIsMenuOpen] = useState(false)
    const handleMenuOpen = useCallback(() => {
      setIsMenuOpen(true)
    }, [])

    const handleMenuClose = useCallback(() => {
      setIsMenuOpen(false)
    }, [])

    return (
      <LexicalComposer initialConfig={initialConfig}>
        <div
          className={
            placeHolder === "Введите комментарий"
              ? styles.CommentPlugin_CommentInputBox_EditorContainer
              : styles.CommentPlugin__EditorContainer
          }
        >
          <PlainTextPlugin
            contentEditable={<ContentEditable className={className} />}
            placeholder={<div className={styles.placeholder}> {placeHolder}</div>}
            ErrorBoundary={LexicalErrorBoundary}
          />
          <MentionsPlugin
            triggers={["@"]}
            menuOpen={ismenuOpen}
            menuComponent={Menu}
            menuItemComponent={MenuItem}
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
          />
          <OnChangePlugin onChange={onChange} />
          <HistoryPlugin />
          {autoFocus !== false && <AutoFocusPlugin />}
          <EscapeHandlerPlugin onEscape={onEscape} />
          <ClearEditorPlugin />
          {editorRef !== undefined && <EditorRefPlugin editorRef={editorRef} />}
        </div>
      </LexicalComposer>
    )
  },
)
PlainTextEditor.displayName = "PlainTextEditor"
